import { BaseService } from "@/script/core/service/BaseService";

export class InvoiceService extends BaseService {}
